import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Divider from "@material-ui/core/Divider";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import { Button } from "@material-ui/core";
import { withRouter } from "react-router-dom";

import Header from "../../../Component/NavBar/User/Header/Header";
import Footer from "../../../Component/NavBar/User/Footer/Footer";
import { useStyles } from "./FAQ.css";

class Faq extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: "",
    };
  }

  handleChange = (panel) => {
    this.state.expanded === panel
      ? this.setState({ expanded: false })
      : this.setState({ expanded: panel });
  };

  handleQuery = () => {
    this.props.history.push("/feedback");
  };

  render() {
    const { classes } = this.props;
    return (
      <div>
        <Header />
        <div className={classes.root}>
          <label style={{ fontSize: 32 }}>Frequently Asked Questions</label>
          <Divider />

          <div className={classes.body}>
            <Accordion
              expanded={this.state.expanded === "panel1"}
              onChange={() => this.handleChange("panel1")}
            >
              <AccordionSummary className={classes.question}>
                What is this?
              </AccordionSummary>
              <Divider />
              <AccordionDetails className={classes.answer}>
                What is this?
              </AccordionDetails>
            </Accordion>
            <br />

            <Accordion
              expanded={this.state.expanded === "panel2"}
              onChange={() => this.handleChange("panel2")}
            >
              <AccordionSummary className={classes.question}>
                What is this?
              </AccordionSummary>
              <Divider />
              <AccordionDetails className={classes.answer}>
                What is this?
              </AccordionDetails>
            </Accordion>
            <br />

            <Accordion
              expanded={this.state.expanded === "panel3"}
              onChange={() => this.handleChange("panel3")}
            >
              <AccordionSummary className={classes.question}>
                What is this?
              </AccordionSummary>
              <Divider />
              <AccordionDetails className={classes.answer}>
                What is this?
              </AccordionDetails>
            </Accordion>
            <br />
          </div>

          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              fontSize: 25,
            }}
          >
            <div>If you have more queries send us</div>
            <div>
              <Button variant="outlined" onClick={this.handleQuery}>
                Feedback
              </Button>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default withStyles(useStyles)(withRouter(Faq));
